class MainCartStickyFooter extends HTMLElement {
  constructor() {
    super();
    this.scrollPosition = 0;
  }

  connectedCallback() {
    // add mobile scroll event only if apple pay is supported
    if (window?.ApplePaySession && this.querySelector('.apple-button')) {
      this.classList.add('apple-pay-supported');
      if (this.querySelector('.checkout-button')) {
        this.classList.add('checkout-button-supported');
      }
      this.classList.add('scrolled');
      document.addEventListener('scroll', this.onScroll.bind(this));
    }
    this.updateBodyPadding();
    window.addEventListener('resize', this.updateBodyPadding.bind(this));
  }

  onScroll() {
    if (window.innerWidth < 768) {
      const fromTop = document.documentElement.scrollTop;
      if (fromTop >= this.scrollPosition) {
        this.classList.add('scrolled');
      } else {
        this.classList.remove('scrolled');
      }
      this.scrollPosition = fromTop;
    }
  }

  updateBodyPadding() {
    // update body padding to avoid content hidden behind the sticky footer
    const footerHeight = this.firstElementChild?.offsetHeight || 0;
    document.body.style.paddingBottom = `${footerHeight}px`;
  }
}

customElements.define('main-cart-footer', MainCartStickyFooter);
